"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImagePreview = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var Behavior_1 = require("../../Behavior");
var ItemTypes_1 = require("./ItemTypes");
var Sendable_1 = require("./Sendable");
var FilePreview_1 = require("./FilePreview");
var ImagePreview = function (_a) {
    var id = _a.id, canDrop = _a.canDrop, primary = _a.primary, preview = _a.preview, onSort = _a.onSort, onFinishSort = _a.onFinishSort, onDelete = _a.onDelete, index = _a.index, progress = _a.progress;
    var _b = (0, react_1.useState)(null), localPreview = _b[0], setLocalPreview = _b[1];
    if (!localPreview && preview && preview.file) {
        setLocalPreview(URL.createObjectURL(preview.file));
    }
    (0, react_1.useEffect)(function () {
        if (localPreview) {
            URL.revokeObjectURL(localPreview);
        }
    }, [localPreview]);
    return ((0, jsx_runtime_1.jsx)(Behavior_1.Sortable, __assign({ id: id, index: index, type: ItemTypes_1.ItemTypes.Image, onSort: onSort, onFinishSort: onFinishSort, sortDirection: "horizontal" }, { children: (0, jsx_runtime_1.jsx)(FilePreview_1.Thumbnail, __assign({ primary: primary }, { children: (0, jsx_runtime_1.jsx)(Sendable_1.Sendable, __assign({ onDelete: onDelete, deletable: canDrop, preview: preview, progress: progress }, { children: preview ? ((0, jsx_runtime_1.jsx)("img", { src: localPreview || preview.downloadUrl || "" }, void 0)) : null }), void 0) }), void 0) }), void 0));
};
exports.ImagePreview = ImagePreview;
